module.exports = __webpack_public_path__ + "static/media/fileActiveIcon.301292b1.svg";